import { Link } from "react-router-dom";

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border/60 bg-background">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8">
          <div>
            <Link to="/" className="font-serif text-xl text-foreground hover:opacity-80 transition-opacity">
              Lifely
            </Link>
            <p className="text-sm text-muted-foreground mt-3 max-w-xs leading-relaxed">
              Clarity for what matters. Context that stays current.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-6 sm:gap-10">
            <div className="flex flex-col gap-3">
              <span className="text-xs uppercase tracking-widest text-muted-foreground/60 font-medium">Pages</span>
              <Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                About
              </Link>
              <Link to="/pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Pricing
              </Link>
              <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Contact
              </Link>
            </div>
            <div className="flex flex-col gap-3">
              <span className="text-xs uppercase tracking-widest text-muted-foreground/60 font-medium">Legal</span>
              <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-border/40">
          <div className="flex flex-col md:flex-row justify-between items-start gap-3">
            <p className="text-xs text-muted-foreground/70">
              &copy; {year} Lifely. All rights reserved.
            </p>
            <p className="text-xs text-muted-foreground/50 max-w-md md:text-right leading-relaxed">
              Lifely is an informational platform and does not provide legal or financial advice.
            </p>
          </div>
          <p className="text-xs text-muted-foreground/50 mt-4 leading-relaxed">
            Lifely is operated by Lifely Holdings Limited (NZBN 9429053450883), a New Zealand limited liability company.
          </p>
        </div>
      </div>
    </footer>
  );
};
